<span class="mat-optgroup-label" aria-hidden="true" [id]="_labelId">{{ label }} <ng-content></ng-content></span>
<ng-content select="mat-option, ng-container"></ng-content>
